import React from 'react';
import { Box } from '@mui/material';

import { ActivityImage } from 'components/common/ActivityImage';
import { ActivityState } from 'types/aspen/events';

import styles from './eventVideoPlaceholder.module.scss';

interface EventVideoPlaceholderProps {
  event: ActivityState;
  show: boolean;
}

export const EventVideoPlaceholder = ({ event, show }: EventVideoPlaceholderProps) => {
  if (!show) return null;

  return (
    <Box className={styles.eventVideoPlaceholder} data-testid="component-event-video-placeholder">
      {event.parameters && <ActivityImage activity={event.parameters} alt="Event preview" />}
    </Box>
  );
};
